module.exports = __webpack_public_path__ + "static/img/title-logo.cbb5f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/title-logo.png
// module id = t0JW
// module chunks = 44